import { Button, Col, Row } from "melco-ui";
import { useTranslation } from "react-i18next";

import { useEffect, useState } from "react";

import { UserProductsSelect } from "./UserProductsSelect";
import { DesignTokens } from "melco-ui";
import { useAccountSupportStatus } from "../../hooks/support/useAccountSupportStatus";
import { useRolesContext } from "../../hooks/roles/useRolesContext";

import {
  IdentityMelcoModelsProductListItem,
  useBaseAPIConfig,
} from "melco-shared-logic";
import { useGetSupportToken } from "../../hooks/users/useGetSupportToken";

type UserProductsAndSupportPropTypes = {
  onSelectProductByUser?: (v: string) => void;
  userId?: string;
  allProducts: IdentityMelcoModelsProductListItem[] | undefined;
};

export const UserProductsAndSupport: React.FC<
  UserProductsAndSupportPropTypes
> = ({ allProducts, onSelectProductByUser, userId }) => {
  const { spacings } = DesignTokens;
  // let token="";
  const [selectedProductByUser, setSelectedProductByUser] = useState<string>();
  //  const token = useUserToken();
  const { t } = useTranslation();
  const accountSupportStatusResponse = useAccountSupportStatus(userId);
  //  const [tokenForProductSupport, setToken] = useState("");
  const [
    selectedCompleteObjectOfProductByUser,
    setSelectedCompleteObjectOfProductByUser,
  ] = useState<IdentityMelcoModelsProductListItem[]>();

  const getSupportToken = useGetSupportToken();

  //const baseApiConfig = useBaseAPIConfig();
  // useEffect(() => {

  //     const fetchToken = async () => {
  //         try {
  //             const api = new SupportApi(baseApiConfig({ token }));

  //             const response = await api.supportGenerateToken(
  //                 {
  //                     "melcoCoreModelsCreateSupportToken": {
  //                         "for_user": userId
  //                     }
  //                 }
  //             );
  //             setToken(response?.token ?? "");
  //         } catch (error) {
  //             console.log("error", error);
  //         }
  //     };

  //     fetchToken();
  // }, []);

  useEffect(() => {
    let selectedCompleteObjectOfProductByUser = allProducts?.filter((p) => {
      return p.code === selectedProductByUser;
    });
    setSelectedCompleteObjectOfProductByUser(
      selectedCompleteObjectOfProductByUser
    );
  }, [selectedProductByUser]);

  const { roles } = useRolesContext();
  // const {productUrls} = useAppDomain();

  const defaultLoadingFn = (v: string) => {
    setSelectedProductByUser(v);
    if (onSelectProductByUser) {
      onSelectProductByUser(v);
    }
  };

  return (
    <>
      <Row gutter={[spacings.middle, spacings.middle]}>
        <Col xl={18} xs={12}>
          <UserProductsSelect
            userId={userId}
            onChange={(value) => {
              //              console.log(value)
              setSelectedProductByUser(value);
              if (onSelectProductByUser) {
                onSelectProductByUser(value);
                //  console.log(value)
              }
            }}
            value={selectedProductByUser ? selectedProductByUser : undefined}
            // value = ""
            defaultLoading={defaultLoadingFn ?? undefined}
          />
        </Col>
        <Col xl={6} xs={6}>
          <>
            {roles.USERS_ACCESS_CUSTOMER_ACCOUNT &&
              accountSupportStatusResponse.data?.is_active &&
              selectedCompleteObjectOfProductByUser &&
              selectedCompleteObjectOfProductByUser[0].app_startup_endpoint !==
              "" &&
              selectedCompleteObjectOfProductByUser[0].is_impersonation && (
                <Button
                  onClick={async () => {
                    if (selectedProductByUser) {
                      let supportTokenObj = await getSupportToken(userId ?? "");

                      if (supportTokenObj?.success) {
                        let urlToOpen =
                          selectedCompleteObjectOfProductByUser[0]
                            .app_startup_endpoint +
                          "login/support?token=" +
                          supportTokenObj.token;
                        window.open(urlToOpen);
                      } else {
                        console.log(
                          "Can not redirect / open client product page , ",
                          supportTokenObj
                        );
                      }
                    }
                  }}
                >
                  {t("users.product_and_support.button")}
                </Button>
              )}
          </>
        </Col>
      </Row>
    </>
  );
};
